import { serviceUrls } from "./constant";
import {
  get,
  put,
  post,
  getLocalStorageData,
} from "../services/axiosComponent";
import { STUDENT_STORAGE_KEYS } from "./student-Services";
import { prepareRegionList } from "./utilityFunctions";
export const login = async (data) => {
  try {
    var res = await post({
      url: serviceUrls.ADMIN_SERVICE + "/open/token",
      data,
    });

    if (res.status == "success") {
      console.log("Logged in successfully:", res);
      console.log("logges in and saved token");

      // Store tokens temporarily with regular keys first
      localStorage.setItem("accessToken", res.data.accessToken);
      console.log(localStorage.getItem("accessToken"), "accessToken");
      localStorage.setItem("refreshToken", res.data.refreshToken);

      return await getProfileDetails();
    }
    return res;
  } catch (error) {
    console.error("Login error:", error);
    return {
      status: "error",
      message: "Login failed. Please try again.",
    };
  }
};

// comment just for pushing from my end..

export const getProfileDetails = async () => {
  try {
    console.log("Fetching profile details...");

    var res = await get({
      url: serviceUrls.ADMIN_SERVICE + "/default/user/profile",
    });

    if (res.status == "success") {
      console.log("profile details", res);

      const isStudent = res.data["USER TYPE"] == "UT-STUDENT";

      if (isStudent) {
        console.log("User is a student, using student storage keys");

        // Move tokens from regular keys to student keys
        const accessToken = localStorage.getItem("accessToken");
        const refreshToken = localStorage.getItem("refreshToken");

        // Store with student keys
        localStorage.setItem(STUDENT_STORAGE_KEYS.ACCESS_TOKEN, accessToken);
        localStorage.setItem(STUDENT_STORAGE_KEYS.REFRESH_TOKEN, refreshToken);
        localStorage.setItem(STUDENT_STORAGE_KEYS.isStudent, "true");

        // Store student profile with additional data
        const studentData = {
          ...res.data,
          loginTime: new Date().toISOString(),
          userType: "STUDENT",
        };

        localStorage.setItem(
          STUDENT_STORAGE_KEYS.PROFILE_DETAILS,
          JSON.stringify(studentData)
        );

        // Clean up regular keys
        localStorage.removeItem("accessToken");
        localStorage.removeItem("refreshToken");

        console.log("Student profile saved:", studentData);
        console.log("Student tokens saved");
      } else {
        console.log("User is not a student, using regular storage keys");

        // Store with regular keys
        localStorage.setItem("profileDetails", JSON.stringify(res.data));
        localStorage.setItem("isStudent", "false");

        console.log(
          "profile detailssss",
          JSON.parse(localStorage.getItem("profileDetails"))
        );
      }

      prepareRegionList();
    }
    return res;
  } catch (error) {
    console.error("Error fetching profile details:", error);
    return {
      status: "error",
      message: "Failed to fetch profile details",
    };
  }
};

export const signUp = async (data) => {
  return await post({ url: serviceUrls.ADMIN_SERVICE + "/open/onboard", data });
};
export const resendOtp = async (data) => {
  return await put({ url: serviceUrls.ADMIN_SERVICE + "/open/onboard", data });
};
export const verifyOtp = async (data) => {
  return await post({ url: serviceUrls.ADMIN_SERVICE + "/open/onboard/verify", data });
};
export const onBoardOrganization = async (data) => {
  return await post({
    url: serviceUrls.ADMIN_SERVICE + "/default/onboard/organization",
    data,
    pathParams: { userId: getLocalStorageData("profileDetails")["_ID"] },
  });
};
export const onBoardRegion = async (data) => {
  return await post({
    url: serviceUrls.ADMIN_SERVICE + "/default/onboard/organization/regions",
    data,
  });
};
export const onBoardSite = async (data) => {
  return await post({
    url: serviceUrls.ADMIN_SERVICE + "/default/onboard/organization/sites",
    data,
  });
};